import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import DefaultPage from '../../Pages/DefaultPage/DefaultPage'
import { StatsProvider } from '../../Context/StatsContext/StatsContext'
import { StandingsProvider } from '../../Context/StandingsContext/StandingsContext'

export const StatsContextLayout: React.FC = () => {
  return (
    <Suspense fallback={<DefaultPage />}>
      <StandingsProvider>
      <StatsProvider>
        <Outlet />
      </StatsProvider>
      </StandingsProvider>
    </Suspense>
  )
}
